/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IncidentFormFindOneResponse } from './IncidentFormFindOneResponse';
import {
    IncidentFormFindOneResponseFromJSON,
    IncidentFormFindOneResponseFromJSONTyped,
    IncidentFormFindOneResponseToJSON,
} from './IncidentFormFindOneResponse';

/**
 * 
 * @export
 * @interface FindIncidentForm200Response
 */
export interface FindIncidentForm200Response {
    /**
     * 
     * @type {IncidentFormFindOneResponse}
     * @memberof FindIncidentForm200Response
     */
    data?: IncidentFormFindOneResponse;
}

/**
 * Check if a given object implements the FindIncidentForm200Response interface.
 */
export function instanceOfFindIncidentForm200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindIncidentForm200ResponseFromJSON(json: any): FindIncidentForm200Response {
    return FindIncidentForm200ResponseFromJSONTyped(json, false);
}

export function FindIncidentForm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindIncidentForm200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : IncidentFormFindOneResponseFromJSON(json['data']),
    };
}

export function FindIncidentForm200ResponseToJSON(value?: FindIncidentForm200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': IncidentFormFindOneResponseToJSON(value.data),
    };
}

